import { render, staticRenderFns } from "./AnimalPrimaryAvatar.vue?vue&type=template&id=79a48d5e&scoped=true&"
import script from "./AnimalPrimaryAvatar.vue?vue&type=script&lang=js&"
export * from "./AnimalPrimaryAvatar.vue?vue&type=script&lang=js&"
import style0 from "./AnimalPrimaryAvatar.vue?vue&type=style&index=0&id=79a48d5e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a48d5e",
  null
  
)

export default component.exports